/**
 * Main entry point for the ARTIFACT frontend
 */

import { initQuickSearch } from './components/search.js';
import { initNavigation } from './components/navigation.js';

// Initialize the application
document.addEventListener('DOMContentLoaded', async () => {
  console.log('ARTIFACT initialized');
  
  // Initialize navigation with authentication state
  await initNavigation();
  
  // Initialize quick search on homepage
  if (document.getElementById('quick-search')) {
    initQuickSearch();
  }
});
